import API from "@/models/API";

export default class EmailThemes {


    static getAll = (payload) =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/email-themes${payload.query}`
        );
        
    static getOne = (id) =>
        API.get(
            `/companies/${localStorage.getItem("storeId")}/email-themes/${id}`
        );
    
    static uploadThumbnail = (image) =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/email-themes/thumbnail`,
            image
        );
        
    static create = item =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/email-themes/`,
            item
        );
        
    static update = item =>
        API.put(
            `/companies/${localStorage.getItem("storeId")}/email-themes/${item.store_email_theme_id}`,
            item
        );

        
        static delete = item =>
        API.delete(
            `/companies/${localStorage.getItem("storeId")}/email-themes/${item.store_email_theme_id}`
        );
}
